import { render, staticRenderFns } from "./GenericConfirmationModal.vue?vue&type=template&id=490156c1&scoped=true&"
import script from "./GenericConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./GenericConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericConfirmationModal.vue?vue&type=style&index=0&id=490156c1&lang=scss&scoped=true&"
import style1 from "./GenericConfirmationModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490156c1",
  null
  
)

export default component.exports